// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__jc8OU","fileDisabled":"File_fileDisabled__2b7I7"};